
export * from './catalog-filters';

import { CatalogFiltersComponent  } from "./catalog-filters";

export const CatalogLayoutMolecules = [
    CatalogFiltersComponent    
]